import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { GetLocationListResponseType } from 'features/Location/@types/location'
import {
  GetMasterAreaPickingListResponseType,
  MasterAreaPickingDataType,
  MasterAreaPickingQueryType,
} from 'features/MasterAreaPicking/services/masterAreaPicking'

export type AreaAddEditSliceType = {
  isLoading: boolean
  isLocationLoading: boolean
  query: MasterAreaPickingQueryType
  masterAreaPickingList: GetMasterAreaPickingListResponseType['data']
  pagination: GetMasterAreaPickingListResponseType['pagination']
  masterAreaPickingDetail: MasterAreaPickingDataType
  locationList: GetLocationListResponseType['content']
}

const initialState: AreaAddEditSliceType = {
  isLoading: false,
  isLocationLoading: false,
  masterAreaPickingList: [],
  masterAreaPickingDetail: {} as MasterAreaPickingDataType,
  query: {
    page_size: '10',
    page_index: 1,
  },
  pagination: {
    page_size: '10',
    page_index: 0,
    total_elements: 0,
  },
  locationList: [],
}

export const SLICE_NAME = 'masterAreaPicking'

const masterAreaPickin = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    reset: () => initialState,
    setQuery: (state, action: PayloadAction<MasterAreaPickingQueryType>) => {
      state.query = action.payload
    },
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    setIsLocationLoading: (state, action: PayloadAction<boolean>) => {
      state.isLocationLoading = action.payload
    },
    setMasterAreaPickingList: (
      state,
      action: PayloadAction<GetMasterAreaPickingListResponseType>,
    ) => {
      state.masterAreaPickingList = action.payload.data
      state.pagination = action.payload.pagination
    },
    setMasterAreaPickingDetail: (state, action: PayloadAction<MasterAreaPickingDataType>) => {
      state.masterAreaPickingDetail = action.payload
    },
    setLocationList: (state, action: PayloadAction<GetLocationListResponseType['content']>) => {
      state.locationList = action.payload
    },
  },
})

export default masterAreaPickin.reducer
export const {
  reset,
  setQuery,
  setIsLoading,
  setIsLocationLoading,
  setMasterAreaPickingList,
  setMasterAreaPickingDetail,
  setLocationList,
} = masterAreaPickin.actions
